import Swiper from 'swiper';
import { A11y, Keyboard, Navigation, Pagination } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

type RelatedArticles = {
  init: () => void;
};

const RelatedArticles: RelatedArticles = {
  init() {
    const relatedArticlesElements = document.querySelectorAll('[data-hook=relatedArticles]');
    const pageTemplate = document.body.dataset.template;

    if (relatedArticlesElements.length === 0) return;

    relatedArticlesElements.forEach((relatedArticlesElement) => {
      const swiperContainer: HTMLElement | null = relatedArticlesElement.querySelector('.swiper');

      const nextButton = relatedArticlesElement?.querySelector('.swiper-button-next') as HTMLElement;
      const prevButton = relatedArticlesElement?.querySelector('.swiper-button-prev') as HTMLElement;

      const pagination = relatedArticlesElement?.querySelector('.swiper-pagination') as HTMLElement;

      if (swiperContainer) {
        const slides: HTMLElement[] = Array.from(relatedArticlesElement.querySelectorAll('.swiper-slide'));

        if (window.innerWidth > 1000 && slides.length < 4) {
          nextButton.style.display = 'none';
          prevButton.style.display = 'none';
          pagination.style.opacity = '0';
          pagination.style.paddingTop = '0';
        }

        const swiperOptions: SwiperOptions = {
          modules: [A11y, Keyboard, Navigation, Pagination],
          slidesPerView: 1.25,
          slidesPerGroup: 1,
          spaceBetween: 20,
          breakpointsBase: 'container',
          breakpoints: {
            320: {
              slidesPerView: 1.15,
            },
            600: {
              slidesPerView: 1.5,
            },
            700: {
              slidesPerView: 2.15,
            },
            960: {
              slidesPerGroup: 3,
              slidesPerView: 3,
            },
            1060: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
          loop: false,
          navigation: {
            nextEl: nextButton, // '.swiper-button-next',
            prevEl: prevButton, // '.swiper-button-prev',
          },
          a11y: {
            enabled: true,
            slideRole: 'listitem',
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          pagination: {
            el: pagination,
            type: 'bullets',
            clickable: true,
          },
        };

        // Adjust config based on page template
        if (pageTemplate === 'Rsfh.SideNavPageTemplate') {
          swiperOptions.breakpoints = {
            320: {
              slidesPerView: 1.15,
            },
            600: {
              slidesPerView: 1.5,
            },
            700: {
              slidesPerView: 2.15,
            },
            820: {
              slidesPerGroup: 3,
              slidesPerView: 3,
            },
          };
        }

        // skipcq: JS-R1002
        new Swiper(swiperContainer, swiperOptions);
      }
    });
  },
};

export default RelatedArticles;
